import { getSecureLocalItem } from "utils/secureSessionStorage";
import api from "./api";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const getAllVendorOrders = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getAllVendorOrders", config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPaymentDetails = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getpaymentDetails", config);
    return response;
  } catch (error) {
    throw error;
  }
};

//Get All Payment By Admin
export const getPaymentDetailsByAdmin = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getAllPayments", config);
    return response;
  } catch (error) {
    throw error;
  }
};

//  Update delivery status API
export const updateDeliveryStatus = async (orderId, deliveryStatus) => {
  try {
    const config = await getAuthConfig();
    const payload = { deliveryStatus };
    const response = await api.put(`/updateDeliveryStatus/${orderId}`, payload, config);
    return response;
  } catch (error) {
    throw error;
  }
};

//  Get all orders (admin API)
export const getAllOrders = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getAllOrders", config);
    return response;
  } catch (error) {
    throw error;
  }
};

//  Get all return orders API
export const getAllReturnOrders = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getAllReturnOrders", config);
    return response;
  } catch (error) {
    throw error;
  }
};

// Update return status API
export const updateReturnStatus = async (orderId, action) => {
  try {
    const config = await getAuthConfig();
    const payload = { action };
    const response = await api.put(`/orderReturn/${orderId}`, payload, config);
    return response;
  } catch (error) {
    throw error;
  }
};